import React from 'react'
import { DropdownButton } from 'react-bootstrap'

const ActionButton = props => {
  return (
    <div className="text-center">
      <DropdownButton
        id="dropdown-basic-button"
        title="Actions"
        pullRight
        className="btn-myed btn-default-myed btn-sm-myed"
      >
        {props.children}
      </DropdownButton>
    </div>
  )
}

export default ActionButton
